module.exports = __webpack_public_path__ + "static/img/rank_331.da27d56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_331.png
// module id = RPyy
// module chunks = 0